import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router';

import Breadcrumbs from '@/components/Breadcrumbs';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageSubtitle from '@/components/PageSubtitle';
import PageTitle from '@/components/PageTitle';

import Chart from './Chart';
import Table from './Table';
import TopBar from './TopBar';

class PurchasesStatistics extends Component {
  static propTypes = {
    defaultMetricsPageUrl: PropTypes.string.isRequired,
    error: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
    itemsIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    statsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const {
      defaultMetricsPageUrl,
      error,
      isLoading,
      itemsIds,
      statsIds,
      totalCount,
    } = this.props;

    if (!statsIds.length) {
      return <Redirect to={defaultMetricsPageUrl} />;
    }

    return (
      <Page>
        <PageHeader borderBottom>
          <Breadcrumbs />
          <PageTitle gutterBottom={false}>Статистика</PageTitle>
          <PageSubtitle>
            Статистика ограничена только вашим магазином.
          </PageSubtitle>
        </PageHeader>
        <PageContent>
          <TopBar />
          <Chart />
          <Table
            error={error}
            isLoading={isLoading}
            items={itemsIds}
            totalCount={totalCount}
          />
        </PageContent>
      </Page>
    );
  }
}

export default PurchasesStatistics;
